import * as React from 'react';
import {HeaderMenuData} from "../../../navigation/route/HeaderRoutes";
import {Link} from "react-router-dom";
import "./header.scss";
import HeaderMenu from "./menu/HeaderMenu";
import SmsCenterMenu from "./smsCenter/SmsCenterMenu";
import NotificationMenu from "./notification/NotificationMenu";
import ProfileMenu from "./profile/ProfileMenu";

const classNames = require('classnames');

/**
 * Below this width the menu folds behind a button; header.scss uses the same width.
 */
const COMPACT_MEDIA_QUERY = "(max-width: 899px)";

interface Props {
	/**
	 * Header menu data.
	 */
	menuData: HeaderMenuData[];
}

interface State {
	/**
	 * Indicates if the screen is too narrow for the menu to fit in the header.
	 */
	compact: boolean;
	/**
	 * Indicates if the folded menu is open.
	 */
	menuOpen: boolean;
}

/**
 * Header component.
 */
export default class Header extends React.Component<Props, State> {
	compactQuery: MediaQueryList | null = window.matchMedia ? window.matchMedia(COMPACT_MEDIA_QUERY) : null;
	header: HTMLElement | null = null;

	constructor(props: Props) {
		super(props);
		this.state = {
			compact: !!this.compactQuery && this.compactQuery.matches,
			menuOpen: false
		};
	}

	componentDidMount() {
		if (this.compactQuery) {
			this.compactQuery.addListener(this.onCompactChange);
		}
		document.addEventListener("mousedown", this.onOutsideClick);
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		if (this.compactQuery) {
			this.compactQuery.removeListener(this.onCompactChange);
		}
		document.removeEventListener("mousedown", this.onOutsideClick);
		document.removeEventListener("keydown", this.onKeyDown);
	}

	render() {
		return (
			<header className="c-header" ref={el => this.header = el}>
				<Link to={'/'} className={"c-header_logo"}>
					<img alt={"Hiber"} src={"/assets/img/dg-logo-white.png"} width={70} height={70}/>
				</Link>
				<button type={"button"}
						className={"c-header_burger"}
						aria-label={"Menu"}
						aria-expanded={this.state.menuOpen}
						aria-controls={"main-menu"}
						onClick={() => this.setState({menuOpen: !this.state.menuOpen})}>
					<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
						<path fill="#fff" d="M3 6h18v2H3zm0 5h18v2H3zm0 5h18v2H3z"/>
					</svg>
				</button>
				<div id={"main-menu"} className={classNames("c-header_menu", {"is-open": this.state.menuOpen})}>
					<HeaderMenu data={this.props.menuData}
								compact={this.state.compact}
								onNavigate={this.closeMenu}/>
				</div>
				<SmsCenterMenu/>
				<NotificationMenu/>
				<ProfileMenu/>
			</header>
		);
	}

	onCompactChange = (query: MediaQueryList) => {
		this.setState({compact: query.matches, menuOpen: false});
	}

	closeMenu = () => {
		if (this.state.menuOpen) {
			this.setState({menuOpen: false});
		}
	}

	onOutsideClick = (event: MouseEvent) => {
		if (this.state.menuOpen && this.header && !this.header.contains(event.target as Node)) {
			this.closeMenu();
		}
	}

	onKeyDown = (event: KeyboardEvent) => {
		if (event.key === "Escape") {
			this.closeMenu();
		}
	}
}
